<template>

    <form v-on:submit.prevent="">

        <BaseInputFloatinglabel v-model="form.name"
                                icon="bullseye"
                                placeholder="Name"
                                type="text"/>

        <div class="action">
          <BaseButton v-if="type === 'create'"
                       :loading="creating"
                       :disabled="checkForm || creating"
                       icon="plus"
                       label="Erstellen"
                       :submit="true"
                       @click="create"/>
          <BaseButton v-if="hasManagerRole && type === 'edit'"
                       :loading="removing"
                       :disabled="removing"
                       icon="trash"
                       label="Löschen"
                       :remove="true"
                       @click="remove"/>
          <BaseButton v-if="type === 'edit'"
                       :loading="updating"
                       :disabled="checkForm || updating"
                       icon="save"
                       label="Speichern"
                       :submit="true"
                       @click="update"/>
        </div>

    </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'InfluencerAudienceForm',
  props: ['influencerAudience', 'type'],
  data () {
    return {
      form: {},
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.influencerAudience)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        const response = await this.createInfluencerAudience({ data: this.form })
        this.$vfm.hide('influencer-audience-create')
        this.$toasted.success('Influencer Zielgruppe ' + response.data.name + ' erstellt', { icon: 'fas fa-bullseye' })
        this.creating = false
        await this.getInfluencerAudiences()
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        const response = await this.updateInfluencerAudience({ id: this.form.id, data: this.form })
        this.$vfm.hide('influencer-audience-edit')
        this.$toasted.success('Influencer Zielgruppe ' + response.data.name + ' gespeichert', { icon: 'fas fa-bullseye' })
        this.updating = false
        await this.getInfluencerAudience({ id: this.form.id })
      } catch (error) {
        this.updating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteInfluencerAudience({ id: this.form.id })
        this.$vfm.hide('influencer-audience-edit')
        this.$toasted.success('Influencer Kategorie gelöscht', { icon: 'fas fa-bullseye' })
        this.removing = false
        await this.getInfluencerAudiences()
      } catch (error) {
        this.removing = false
      }
    },
    ...mapActions({
      createInfluencerAudience: 'influencerAudiences/create',
      updateInfluencerAudience: 'influencerAudiences/replace',
      deleteInfluencerAudience: 'influencerAudiences/destroy',
      getInfluencerAudience: 'influencerAudiences/fetchSingle',
      getInfluencerAudiences: 'influencerAudiences/fetchList'
    })
  },
  computed: {
    checkForm () {
      return !this.form.name
    },
    ...mapGetters({
      hasManagerRole: 'auth/hasManagerRole'
    })
  }
}
</script>
